import { Button, Icon, message } from 'antd';
import api from 'api';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { GetQueryString, GetQueryStringByUrl } from 'utils';
import './index.less';
import { AppAction } from '../../../qcc/AppAction/index';
import { AppMaskLayer } from 'qcc';

export default class extends React.Component<RouteComponentProps> {
  state = { voucher: {} as any, contractImgageUrl: '', loading: true }

  async componentDidMount() {
    let params = this.props.match.params as any
    let id: number = params.id || 0;
    let key = GetQueryString('key') || '';
    let keys = GetQueryString('keys') || '';
    let type = GetQueryString('type') || '';
    if (id === 0 && keys == null) return;
    console.log({ id, key })

    let res = await api.public.printBill({ id, key,keys,type });
    console.log("res", res)
    if (!res.result) {
      message.error(res.msg);
    } else {
      this.setState({ voucher: res.data })
    }

    this.getContractImgUrl()
    setTimeout(() => { this.setState({ loading: false }) }, 2000)
  }

  downFile = async () => {
    let { voucher } = this.state;
    // let projectId = voucher.projectId;
    // let project = await api.mdmproject.getOne({ id: projectId });
    window.location.href = `/api/public/download?filePath=/images/${voucher.voucherPath}/${voucher.id}.pdf&fileName=${voucher.projectName}_${voucher.billNo}.pdf`;
  }

  print = async () => {
    // window.open(this.state.contractImgageUrl)
    this.refIfra.current && this.refIfra.current.contentWindow.print();
  }


  getContractImgUrl = async () => {
    let electronicBillUrl = this.state.voucher.electronicBillUrl || ''
    let params = electronicBillUrl.split('?').length > 1 ? electronicBillUrl.split('?')[1] : ''

    let appId = { 'name': 'app_id', value: GetQueryStringByUrl(params, 'app_id') || '' }
    let timestamp = { 'name': 'timestamp', value: GetQueryStringByUrl(params, 'timestamp') || '' }
    let clientUrl = { 'name': 'client_url', value: GetQueryStringByUrl(params, 'client_url') || '' }
    let msgDigest = { 'name': 'msg_digest', value: GetQueryStringByUrl(params, 'msg_digest') || '' }
    let uuid = { 'name': 'uuid', value: await api.public.getContractImgageUrl({ id: this.state.voucher.id }) }
    let accessToken = { 'name': 'access_token', value: '' }
    let baseUrl = electronicBillUrl.split('?')[0].replace('view_contract', 'get_contract_image')
    let getUrl = `${clientUrl.name}=${clientUrl.value}/get_contract_image?${appId.name}=${appId.value}&${timestamp.name}=${timestamp.value}&${msgDigest.name}=${msgDigest.value}&${uuid.name}=${uuid.value}&${accessToken.name}=${accessToken.value}`
    this.setState({ contractImgageUrl: `${baseUrl}?${getUrl}` })
    console.log('111', encodeURIComponent(`${baseUrl}?${getUrl}`))
  }


  refIfra = React.createRef<HTMLIFrameElement>();

  render() {
    if (this.state.voucher.id) {
      return (
        <div className='page-pos-print-voucher'>
          {this.state.loading ? <AppMaskLayer /> : <React.Fragment />}
          <div className='page-pos-print-voucher-header'>
            <div className='page-pos-print-voucher-header-content'>
              <Button.Group>
                <Button type="primary" onClick={this.downFile}>
                  <Icon type="download" />
                  PDF下载
                   </Button>
                <Button type="primary" onClick={this.print}>
                  打印
                     <Icon type="printer" />
                </Button>
              </Button.Group>
            </div>
          </div>
          <iframe className='page-pos-print-voucher-iframe'
            src={this.state.voucher.electronicBillUrl || ''}>
          </iframe>

          <iframe style={{ display: 'none' }} ref={this.refIfra}
            src={`/pos/voucher_print/print?id=${this.state.voucher.id}&voucherPath=${this.state.voucher.voucherPath}&contractImgageUrl=${encodeURIComponent(this.state.contractImgageUrl || '')}`}>
          </iframe>
        </div>
      )

    }
    return <div className='page-pos-print-voucher'></div>
  }
}


// WEBPACK FOOTER //
// ./src/page/interface/voucher/index.tsx